import React, { useCallback, useEffect, useState } from 'react';

import { Alert } from "rsuite";
import { ZERO as RSUITE_ALERT_DO_NOT_CLOSE } from "common/constants";
import { usePaymentUIState } from '../../../use-payment-ui-state';
import { FieldLabel } from '../../shared-styles';
import {
  CardField,
  CardFieldGroup,
  FormStyles,
  HearlandForm,
} from '../heartland-styles';
import { handleTokenError } from '../utils';
import { strRegistrationApiSender } from 'utils/str-registration-api-sender';

const CARD_HOLDER_ID = 'credit-card-card-holder';

export const Card = (props) => {
  const { email, signatory } = props;
  const { paymentFees } = usePaymentUIState({ email, signatory });
  const [initialized, setInitialized] = useState(false);

  const onFormReady = useCallback(() => {
    setInitialized(true);
  }, []);

  const handleSubmit = useCallback(async (token) => {
    const { data } = await strRegistrationApiSender.post('/payCC', {
      paymentId: paymentFees.paymentId,
      signatory: props.signatory,
      email: props.email,
      token_id: token,
    });

    const error = false;

    // Check for errors in stripe transaction
    if (error) {
      /*
       * Errors can be card_error, api_error, idempotency_error, invalid_request_error.
       * Here we only display the nice `error.message` msg for card_error. Else we want
       * the user to see our own custom error message string
      */
      /*if (result.error.type === CARD_ERROR) {
        alertMsg = result.error.message;
      }
      **/
      Alert.error("An Error was produced", RSUITE_ALERT_DO_NOT_CLOSE);
      // throw new Error(result.error.code);
    } else  {
      await props.onSuccess();
    }
  }, [paymentFees, props]);

  const onTokenSuccess = useCallback((resp) => {
    handleSubmit(resp.paymentReference);
  }, [handleSubmit]);

  const onTokenError = useCallback(handleTokenError, []);

  useEffect(() => {
    if (window.GlobalPayments.ui.form && initialized) {
      return;
    }
    const cardForm = window.GlobalPayments.ui.form({
      fields: {
        'card-holder-name': {
          placeholder: 'Jane Smith',
          target: `#${CARD_HOLDER_ID}`,
        },
        'card-number': {
          placeholder: '•••• •••• •••• ••••',
          target: '#credit-card-card-number',
        },
        'card-expiration': {
          placeholder: 'MM / YYYY',
          target: '#credit-card-card-expiration',
        },
        'card-cvv': {
          placeholder: '•••',
          target: '#credit-card-card-cvv',
        },
        submit: {
          value: 'submit',
          target: '#credit-card-submit',
          text: paymentFees.label,
        },
      },
      style: 'blank',
      styles: FormStyles,
    });
    cardForm.ready(onFormReady);
    cardForm.on('token-success', onTokenSuccess);
    cardForm.on('token-error', onTokenError);
  }, [initialized, onFormReady, onTokenError, onTokenSuccess, paymentFees]);

  return (
    <>
      <>
        This payment will be handled by an external payment processing provider.
      </>
      <HearlandForm id="payment-form" action="/charge" method="get">
        <FieldLabel>Card Information</FieldLabel>
        <div id="credit-card">
          <CardFieldGroup>
            <CardField id={CARD_HOLDER_ID} />
          </CardFieldGroup>
          <CardFieldGroup>
            <CardField id="credit-card-card-number" />
          </CardFieldGroup>
          <CardFieldGroup>
            <CardField id="credit-card-card-expiration" />
            <CardField id="credit-card-card-cvv" />
          </CardFieldGroup>
          <CardField id="credit-card-submit" />
        </div>
      </HearlandForm>
    </>
  );
};
